import { Path } from "features/Path/models";
import { generatePath } from "helpers/url/pages/v1";
import { SHARED_ROUTES } from "definitions/constants/routeConstants";

export function v2pathPathById(pathId: string) {
  return generatePath({ path: SHARED_ROUTES.paths.show, params: { id: pathId || "" } });
}

export function v2pathPath(path: Path) {
  return v2pathPathById(path?.id);
}

export function v2prebuiltPathPathById(prebuiltPathId: string) {
  return generatePath({ path: SHARED_ROUTES.prebuilt.paths.show, params: { id: prebuiltPathId || "" } });
}
